import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const TreeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
`;

export const ParentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 100px;
  position: relative;
  z-index: 2;
`;

export const ChildrenWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
  margin-left: 32px;
  position: relative;

  /* linha vertical conectada ao pai */
  &::before {
    content: '';
    position: absolute;
    top: -16px; /* sobe a linha para tocar o pai */
    left: -28px;
    width: 2px;
    height: calc(100% + 16px); /* estende a linha até o último filho */
    border-left: 2px solid ${colors.Grey200};
  }

  /* corta o traço após o último filho */
  & > div:last-child::after {
    content: '';
    position: absolute;
    left: -28px;
    bottom: 0;
    width: 2px;
    height: 48%;
    background: white; /* cor de fundo para “apagar” o excesso */
  }
`;

export const ChildItem = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const Connector = styled.div`
  width: 16px;
  margin-left: -28px;
  border-top: 2px solid ${colors.Grey200};
`;
